<template>
    <div class="form-container">
        <div class="form-header">
            <div class="form-tab" :class="tab === 'round-trip' ? 'active' : ''" v-on:click="changeTab('round-trip')">
                <span class="active-dot"></span>Round trip
            </div>
            <div class="form-tab" :class="tab === 'one-way' ? 'active' : ''" v-on:click="changeTab('one-way')">
                <span class="active-dot"></span>One way
            </div>
            <div class="form-tab" :class="tab === 'multi-city' ? 'active' : ''" v-on:click="changeTab('multi-city')">
                <span class="active-dot"></span>Multi-city
            </div>
        </div>
        <RoundTripForm
            v-if="tab === 'round-trip'"
            :cabin-classes-options="cabinClassesOptions"
            :passengers-count-options="passengersCountOptions"
        />
        <OneWayForm
            v-if="tab === 'one-way'"
            :cabin-classes-options="cabinClassesOptions"
            :passengers-count-options="passengersCountOptions"
        />
        <MultiCityForm
            v-if="tab === 'multi-city'"
            :cabin-classes-options="cabinClassesOptions"
            :passengers-count-options="passengersCountOptions"
        />
    </div>
</template>

<script>
import AirportSearchSelector from './forms_entities/form-fields/AirportsSearchSelector'
import { ModelSelect } from 'vue-search-select'
import Datepicker from 'vuejs-datepicker'
import RoundTripForm from './forms_entities/RoundTripForm'
import OneWayForm from './forms_entities/OneWayForm'
import MultiCityForm from './forms_entities/MultiCityForm'

export default {
    name: 'MainForm',
    data: function () {
        return {
            tab: '',
            cabinClassesOptions: [
                {
                    text: 'Business',
                    value: 'business',
                },
                {
                    text: 'First',
                    value: 'first',
                },
                {
                    text: 'Premium Economy',
                    value: 'premium_economy',
                },
            ],
            passengersCountOptions: [
                {
                    text: '1 passenger',
                    value: 1,
                },
                {
                    text: '2 passengers',
                    value: 2,
                },
                {
                    text: '3 passengers',
                    value: 3,
                },
                {
                    text: '4 passengers',
                    value: 4,
                },
                {
                    text: '5 passengers',
                    value: 5,
                },
                {
                    text: '6 passengers',
                    value: 6,
                },
                {
                    text: '7 passengers',
                    value: 7,
                },
                {
                    text: '8 passengers',
                    value: 8,
                },
                {
                    text: '9 passengers',
                    value: 9,
                },
                {
                    text: '10 passengers',
                    value: 10,
                },
            ],
            item: {
                value: '',
                text: '',
            },
            state: {
                date: new Date(),
                departing: {
                    disabledDates: {
                        to: new Date(),
                    },
                },
                return: {
                    disabledDates: {
                        to: null,
                    },
                },
            },
            searchVal: null,
        }
    },
    watch: {
        $route(to, from) {
            if (to && to.params && to.params.type) {
                this.tab = to.params.type
            }
        },
    },
    mounted() {
        this.tab = this.$route.params.type
    },
    methods: {
        changeTab(tabType) {
            this.$router.push(`/form/${tabType}`).catch((error) => {
                if (error.name !== 'NavigationDuplicated') {
                    throw error
                }
            })
        },
    },
    components: {
        MultiCityForm,
        OneWayForm,
        RoundTripForm,
        ModelSelect,
        Datepicker,
        AirportSearchSelector,
    },
}
</script>

<style lang="scss" scoped>
@import './common-forms-styles';

.form-container {
    display: flex;
    flex-direction: column;
    margin: 45px auto;
    position: relative;
    max-width: 1000px;
    z-index: 50;

    border-radius: 6px;
    background-color: rgba(224, 224, 224, 0.1);

    .form-header {
        display: flex;
        justify-content: space-between;
        padding: 0 30px;

        .form-tab {
            font-family: 'Gilroy-SemiBold', sans-serif;
            color: #c0c0c9;
            padding: 15px 25px;
            text-align: center;

            font-size: 16px;
            line-height: 19px;
            text-transform: uppercase;
            cursor: pointer;
            position: relative;

            &.active {
                text-transform: uppercase;
                color: $mainTextBlueColor;

                .active-dot {
                    width: 7px;
                    height: 7px;
                    background: #000052 0% 0% no-repeat padding-box;
                    border-radius: 50%;
                    opacity: 1;
                    position: absolute;
                    top: 23px;
                    left: 10px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .form-container {
        margin: 20px auto;

        .form-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0 20px;

            .form-tab {
                padding: 15px;
                font-size: 16px;
                line-height: 19px;

                &.active {
                    .active-dot {
                        left: 0;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/MainForm.vue